import { createContext, use } from 'react'

/** The resolved open state of the nearest `Dialog.Root`, in both modes. */
const DialogOpenContext = createContext<boolean | undefined>(undefined)

function useDialogOpenContext(hookName: string): boolean {
  const open = use(DialogOpenContext)
  if (open === undefined) {
    throw new Error(`Read dialog state outside a Dialog.Root: ${hookName} found no open state to follow`)
  }
  return open
}

export { DialogOpenContext, useDialogOpenContext }
